/**
 * <ArchivedActivitiesSkeleton> — la forme des « Activités archivées » pendant leur premier
 * chargement.
 *
 * L'en-tête (titre, croix, flèche) reste : c'est le contenu qui attend. La ligne de tête — le
 * compte « 12 activités de côté » et « Sélectionner » — puis la carte-liste des activités mises
 * de côté, en lignes `<ActivityRowSkeleton>` : celles d'une activité à faire, la forme la plus
 * courante d'une archive.
 */
import React from "react"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { ActivityRowSkeleton } from "../../molecules/ActivityRow/ActivityRowSkeleton"
import { CardList } from "../../molecules/CardList"

export function ArchivedActivitiesSkeleton() {
    return (
        <Stack gap="3">
            <Row justify="between" align="center">
                <Skeleton textSize="text-md" width={150} />
                <Skeleton textSize="text-sm" width={80} />
            </Row>
            <CardList>
                <ActivityRowSkeleton titleWidth={170} />
                <ActivityRowSkeleton titleWidth={120} />
                <ActivityRowSkeleton titleWidth={150} />
                <ActivityRowSkeleton titleWidth={130} />
            </CardList>
        </Stack>
    )
}
